import { InjectionToken, Renderer2 } from '@angular/core';

export const RENDERER_TOKEN = new InjectionToken<Renderer2>('RENDERER_TOKEN');
